/** All available external user statuses */
export enum ExternalUserStatusEnum {
  /** User is active */
  ACTIVE = 'ACTIVE',
  /** User is banned */
  BANNED = 'BANNED',
}
